var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1649 3.33361C14.1098 4.6471 14.6663 6.2587 14.6663 8.00028C14.6663 9.74185 14.1098 11.3535 13.1649 12.6669M10.4965 5.33361C11.0238 6.0895 11.333 7.00878 11.333 8.00028C11.333 8.99177 11.0238 9.91105 10.4965 10.6669M6.42255 2.91073L4.31209 5.02119C4.19679 5.13649 4.13914 5.19414 4.07186 5.23537C4.01222 5.27192 3.94719 5.29886 3.87916 5.31519C3.80244 5.33361 3.72091 5.33361 3.55785 5.33361H2.39967C2.02631 5.33361 1.83962 5.33361 1.69701 5.40627C1.57157 5.47019 1.46959 5.57218 1.40567 5.69762C1.33301 5.84022 1.33301 6.02691 1.33301 6.40028V9.60028C1.33301 9.97364 1.33301 10.1603 1.40567 10.3029C1.46959 10.4284 1.57157 10.5304 1.69701 10.5943C1.83962 10.6669 2.02631 10.6669 2.39967 10.6669H3.55785C3.72091 10.6669 3.80244 10.6669 3.87916 10.6854C3.94719 10.7017 4.01222 10.7286 4.07186 10.7652C4.13914 10.8064 4.19679 10.8641 4.31209 10.9794L6.42255 13.0898C6.70813 13.3754 6.85093 13.5182 6.97352 13.5278C7.07989 13.5362 7.18385 13.4932 7.25314 13.412C7.33301 13.3185 7.33301 13.1166 7.33301 12.7127V3.28786C7.33301 2.88398 7.33301 2.68204 7.25314 2.58853C7.18385 2.5074 7.07989 2.46434 6.97352 2.47271C6.85093 2.48236 6.70813 2.62515 6.42255 2.91073Z",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.c929a7ed05869e38f1c22ddcbe33c472.svg";
export { ForwardRef as ReactComponent };